import type { ReactNode } from 'react';
import React, { Children, isValidElement } from 'react';

import { useTabs } from '../Tabs';

type TabPanelsProps = {
  children: ReactNode;
};

type TabPanelChildProps = {
  'aria-labelledby'?: string;
  id?: string;
  isActive?: boolean;
};

const TabPanels = ({ children }: TabPanelsProps) => {
  const { activeIndex, id } = useTabs();

  return (
    <div className="TabPanels">
      {Children.map(children, (child, index) => {
        if (!isValidElement<TabPanelChildProps>(child)) {
          return null;
        }
        return React.cloneElement(child, {
          'aria-labelledby': `${id}-tab-${index}`,
          id: `${id}-panel-${index}`,
          isActive: index === activeIndex,
        });
      })}
    </div>
  );
};

TabPanels.displayNane = 'TabPanels';

export { TabPanels };
